module.exports = __webpack_public_path__ + "a5db3ff1c0134632ed438592a9410d74.svg";